export const STATUSES = {
  NOT_AVAILABLE: 'N/A',
}
